@if (dialog.active()) {
  <div class="pathways-modal-backdrop" (click)="onBackdropClick()">
    <div
      class="pathways-modal-card pi-send-options-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pi-send-options-title"
      (click)="$event.stopPropagation()"
    >
      <div class="pathways-title-accent-block">
        <h3 id="pi-send-options-title" class="pathways-modal-title">
          Send to Pathways-Intelligence
        </h3>
        <div class="qprime-accent-bar" aria-hidden="true"></div>
      </div>
      <p class="pathways-modal-message">
        Choose how to publish this suggested report. Sending does not mark content as confirmed or
        verified.
      </p>
      <label class="pi-send-title-field">
        <span>Report name</span>
        <input
          type="text"
          autocomplete="off"
          maxlength="200"
          aria-label="Report name"
          [ngModel]="dialog.draftTitle()"
          (ngModelChange)="onTitleChange($event)"
        />
      </label>
      @if (titleError()) {
        <p class="pi-send-title-error" role="alert">{{ titleError() }}</p>
      }
      <div class="pi-send-options-choices">
        <button
          type="button"
          class="pi-send-option-btn"
          (click)="onChoose('as-is')"
        >
          <i class="fa-solid fa-share-nodes" aria-hidden="true"></i>
          <span class="pi-send-option-label">Send as-is</span>
          <span class="pi-send-option-hint">Publish without a password</span>
        </button>
        <button
          type="button"
          class="pi-send-option-btn"
          (click)="onChoose('password-protect')"
        >
          <i class="fa-solid fa-lock" aria-hidden="true"></i>
          <span class="pi-send-option-label">Password-protect &amp; send</span>
          <span class="pi-send-option-hint"
            >Recipients need the passphrase in PI and to open the artifact</span
          >
        </button>
      </div>
      <div class="pathways-modal-actions">
        <button type="button" class="pathways-btn-secondary" (click)="onCancel()">Cancel</button>
      </div>
    </div>
  </div>
}
